import { useState } from "react";
import labels from "../../utils/labels";

const ConstraintComment = ({
  comment,
  isCreate,
  onChange,
}: {
  comment: string;
  isCreate: boolean;
  onChange?: (value: string) => void;
}) => {
  const [localComment, setLocalComment] = useState(comment);

  if (isCreate) {
    return (
      <textarea
        className="p-[var(--spacing-sm)] h-[40px] border border-[var(--col-border-primary)] rounded-[var(--border-radius-minimal)] [font:var(--font-bodyStd)] placeholder:text-[var(--col-text-secondary)] w-full"
        value={localComment}
        rows={1}
        onChange={(e) => {
          setLocalComment(e.target.value);
          onChange?.(e.target.value);
        }}
        placeholder={labels.addCommentPlaceholder}
      />
    );
  }

  return <p>{comment}</p>;
};

export default ConstraintComment;
